import type { LinkType } from 'types'
import Menu from '../../Menu'
import MenuItem from '../../MenuItem'

import style from './style.scss'

type Props = {
  'aria-label'?: string
  links: LinkType[]
}

function renderMenuItem({ text, url }: LinkType) {
  const isActive = window.location.pathname.indexOf(url) === 0

  return (
    <MenuItem
      key={text}
      isActive={isActive}
      style={style}
      text={text}
      url={url}
    />
  )
}

function DesktopMenu(props: Props) {
  const { 'aria-label': ariaLabel, links } = props

  return (
    <Menu aria-label={ariaLabel} className={style.wrapper} style={style}>
      {links.map(renderMenuItem)}
    </Menu>
  )
}

export default DesktopMenu
